import { splitPhoneDisplay } from '../utils/digitMask';

/**
 * PhoneNumberLockup — the way CloudGM renders a phone number: one continuous number,
 * with a light gap between the operator code and the rest (masked X/Y/Z read like digits).
 *
 * size: 'xs' | 'card' | 'sm' | 'md' | 'lg' (detail page hero)
 */
const SIZES = {
  xs: 'text-base',
  card: 'text-lg sm:text-xl',
  sm: 'text-xl sm:text-2xl',
  md: 'text-3xl',
  lg: 'text-4xl sm:text-6xl lg:text-7xl',
};

export default function PhoneNumberLockup({ value, size = 'md', className = '', testId = 'phone-lockup', tone = 'auto' }) {
  const [code, rest] = splitPhoneDisplay(value);
  const color = tone === 'light' ? 'text-white' : tone === 'dark' ? 'text-[#0F172A]' : 'text-[#0F172A] dark:text-white';

  return (
    <span
      dir="ltr"
      className={`cgm-phone-number inline-flex items-baseline justify-center whitespace-nowrap ${SIZES[size] || SIZES.md} ${color} ${className}`}
      data-testid={testId}
    >
      <span data-testid={`${testId}-code`}>{code}</span>
      {rest && <span className="ms-[0.3em]" data-testid={`${testId}-rest`}>{rest}</span>}
    </span>
  );
}
